import React from "react";
import PropTypes from "prop-types";

const TransducerFaultEditor = ({ config, onChange }) => {
  const handleChange = (side, transducer, key, value) => {
    const updatedSide = {
      ...config[side],
      [transducer]: {
        ...config[side][transducer],
        [key]: value,
      },
    };
    onChange({ ...config, [side]: updatedSide });
  };

  return (
    <div className="border rounded p-3 mb-4 bg-gray-100">
      {Object.entries(config).map(([side, transducers]) => (
        <div key={side} className="mb-4">
          <h4 className="font-semibold text-gray-700">{side.toUpperCase()}</h4>
          {Object.entries(transducers).map(([transducerKey, data]) => (
            <div key={transducerKey} className="ml-4 mb-3">
              <h5 className="font-semibold text-sm">{transducerKey}</h5>

              <label className="block mb-1">Trigger Message:</label>
              <input
                type="text"
                value={data.triggerMessage || ""}
                onChange={(e) =>
                  handleChange(
                    side,
                    transducerKey,
                    "triggerMessage",
                    e.target.value
                  )
                }
                className="w-full border px-2 py-1 rounded mb-1"
              />

              <label className="block mb-1">Fault Code:</label>
              <input
                type="text"
                value={data.faultCode || ""}
                onChange={(e) =>
                  handleChange(side, transducerKey, "faultCode", e.target.value)
                }
                className="w-full border px-2 py-1 rounded"
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

TransducerFaultEditor.propTypes = {
  field: PropTypes.string.isRequired,
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TransducerFaultEditor;
